import React, { useEffect, useRef, useState } from 'react'
import Response_Processing from '../../../layout/Others/Response_Processing';
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader';
import FormContainer from '../../../components/CommonComponents/FormContainer';
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper';
import Wrapper from '../../../components/CommonComponents/Wrapper';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import MessageHeading from '../../../components/CommonComponents/MessageHeading';
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect';
import RightWrapper from '../../../components/CommonComponents/RightWrapper';
import AdminCustomArea from '../../../components/CommonComponents/AdminCustomArea';
import AdminImageUploadZone from '../../../components/CommonComponents/AdminImageUploadZone';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif';
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation';
import { slugGenerator } from '../../../components/CommonMethod/CommonMethods';
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from '../../../CustomFields/saveCustomFieldsStrict';
import { getItemToken } from '../../../Utils/localStorageUtils';
import Select from "react-select";
import { IoMdInformationCircle } from 'react-icons/io';
import MessageBox from '../../../components/CommonComponents/MessageBox';

const ArtistAddUpdate = ({ isModal = false, onSuccess, forceCreate = false }) => {

    const { fetchRequest, globalImageUplaodAPI } = useMyContext();

    const { id } = useParams()
    const isEditing = !!id && !forceCreate
    const { location } = useLocation()
    const navigate = useNavigate()
    const baseURL = process.env.REACT_APP_Baseurl
    const headers = getItemToken('access_token')


    const references = `${baseURL}/admin/artist/create`;
    const labelApi = `${baseURL}/admin/Label-Management/list-source`
    const storeApi = `${baseURL}/admin/artist/store`
    const imageUploadApi = globalImageUplaodAPI()
    const editApi = `${baseURL}/admin/artist/edit`
    const updateApi = `${baseURL}/admin/artist/update`

    const [formData, setFormData] = useState({ artist_name: "", artist_slug: "", artist_type: "", artist_email: "", description: "", artist_category_id: "", selected_types: [] })
    const [formDataError, setFormDataError] = useState({})
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [defaultOption, setDefaultOption] = useState({
        categoryOption: [],
        artistCategoryOption: []
    })
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [customFieldValues, setCustomFieldValues] = useState({})

    const combinedRef = useRef({
        artist_name: null,
        artist_slug: null,
        artist_email: null,
        artist_type: null,
        image: null,
    });

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }

        if (type === 'text') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    };

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData((prev) => ({
            ...prev,
            selected_types: selectedOptions,
            artist_type: selectedOptions?.map(opt => opt.value).join(',')
        }))
        setFormDataError((prev) => ({
            ...prev,
            artist_type: ""
        }))
    }

    const generateSlug = async (title) => {
        const slug = await slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'artist_slug': slug,
        }));
    };
    const handleInputKeyDowntitle = (event) => {
        if (!formData?.artist_slug) {
            if (event.key === "Enter" || event.key === "Tab") {
                generateSlug(formData?.artist_name);
            }
        }
    };
    const handleBlurEdittitle = () => {
        generateSlug(formData?.artist_slug);
    }


    const handleBlurtitle = () => {
        if (!formData?.artist_slug) {
            generateSlug(formData?.artist_name);
        }
    };

    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                // reject(new Error('Error loading image'));
                toast.error('Error loading image');
            };
        });
    };

    const handleFileChange = async (event) => {
        const { files, name, value, accept } = event.target
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);

            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));
                setCoverImageFile(null);
                combinedRef.current['image'].focus()
                return;
            }

            if (name == 'image') {
                setCoverImageFile(newFile);
                const isValidSizeEqual = await validateImageRatio(newFile, 1 / 1, 1080, 1080);

                if (!isValidSizeEqual) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 1:1 Ratio or 1080px (x) 1080px",
                    }));
                    combinedRef.current['image'].focus()
                    return;
                }
            }
        }
    };

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))

    }


    const labelFetch = async () => {
        try {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                params: { source: "add-artist" },
                data: {},
            }).then((res) => {
                setLabelDisplay(res?.label_management)
            })
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setLoading(false)
        }
    }

    const formValidation = () => {
        let formIsValid = true;
        setFormDataError({});
        if (!formData?.artist_name) {
            setFormDataError((prev) => ({
                ...prev,
                artist_name: "Artist name cannot be empty.",
            }));
            if (formIsValid) combinedRef.current['artist_name'].focus();
            formIsValid = false;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.artist_name)) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                artist_name: "Artist name should contain only letters.",
            }));
            combinedRef.current['artist_name'].focus();
            formIsValid = false;
        }

        if (!formData?.artist_slug) {
            setFormDataError((prev) => ({
                ...prev,
                artist_slug: "Artist Slug cannot be empty.",
            }));
            if (formIsValid) combinedRef.current['artist_slug'].focus();
            formIsValid = false;
        }
        if (!formData?.artist_type) {
            setFormDataError((prev) => ({
                ...prev,
                artist_type: "Choose one of the artist role.",
            }));
            if (formIsValid) combinedRef.current['artist_type'].focus();
            formIsValid = false;
        }
        if (formDataError?.image) {
            if (formIsValid) combinedRef.current['image'].focus();
            formIsValid = false;
        }

        if (formData?.artist_email) {
            const regex = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/;
            if (!regex.test(formData.artist_email)) {
                setFormDataError((prev) => ({
                    ...prev,
                    artist_email: "Email format is incorrect.",
                }));
                if (formIsValid) combinedRef.current['artist_email'].focus();
                formIsValid = false;
            }
        }
        return formIsValid;
    };

    const handleImageUpload = async (id) => {
        const formDataUpload = new FormData();
        const imageFields = [];
        formDataUpload?.append("id", id);
        formDataUpload?.append("modelName", "Artist");
        formDataUpload.append("image", coverImageFile);
        imageFields.push("image");
        imageFields.forEach((field) => {
            formDataUpload.append('imageFields[]', field);
        });
        await fetchRequest({
            method: 'POST',
            url: `${imageUploadApi}`,
            params: {},
            data: formDataUpload,
        })
            .then(response => {
                if (response?.status) {
                    // toast.success(response?.message)
                }
            }).catch((err) => {
                toast.error(err?.response?.data?.message)
            }).finally(() => {
                setCoverImageFile(null)
            })
    }


    const handleSubmit = (e) => {
        e.preventDefault()
        if (formValidation()) {
            handleAction()
        }
        else {
            console.table("validation")
        }
    }

    const handleAction = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (formData.hasOwnProperty(key)) {
                    formDataAdd[key] = formData[key];
                }
            }

            const response = await fetchRequest({
                method: `${isEditing ? `PATCH` : `POST`}`,
                url: `${isEditing ? `${updateApi}/${id}` : storeApi}`,
                params: {},
                data: formDataAdd,
            });

            if (response?.status) {
                // save custom field values (strict)
                try {
                    const entityId = id || response?.artist_id || response?.id;
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'artist', entityId, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile) {
                    await handleImageUpload(response?.artist_id || id);
                }
                setWithOutRefresh((prev) => !prev)
                toast.success(response?.message);
                const createdId = response?.artist_id || response?.id || id;
                if (typeof onSuccess === 'function') {
                    onSuccess(createdId, formData?.artist_name);
                } else if (!isEditing) {
                    navigate("/all-artist");
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || 'An error occurred.');
        } finally {
            setShowOverlay(false);
        }
    }


    useEffect(() => {
        const initFetch = async () => {
            setLoading(true);
            try {
                // Fetch Artist Categories for both cases
                const categoryResponse = await fetchRequest({
                    method: 'GET',
                    url: `${baseURL}/admin/artist-category/index`,
                });

                let artistCategories = [];
                if (categoryResponse?.status) {
                    artistCategories = categoryResponse?.allArtistCategory || [];
                }
                const formattedOptions = artistCategories.map(item => ({ label: item.name, value: item.id }));

                if (!isEditing) {
                    const response = await fetchRequest({
                        method: 'GET',
                        url: `${references}`,
                        params: {},
                        data: {},
                    });

                    if (response?.status) {
                        setDefaultOption((prev) => ({
                            ...prev,
                            artistCategoryOption: formattedOptions
                        }));
                    }
                } else if (isEditing) {
                    const response = await fetchRequest({
                        method: 'GET',
                        url: `${editApi}/${id}`,
                        params: {},
                        data: {},
                    });

                    if (response?.status) {
                        setDefaultOption((prev) => ({
                            ...prev,
                            artistCategoryOption: formattedOptions
                        }));
                        const artistData = response?.artist;
                        const typeIds = String(artistData?.artist_type || "").split(',');
                        const selectedTypes = formattedOptions.filter(opt => typeIds.includes(String(opt.value)));

                        setFormData({
                            ...artistData,
                            selected_types: selectedTypes
                        });
                    }
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || "Error fetching data");
            } finally {
                setLoading(false);
            }
        };

        initFetch();
    }, [withOutRefresh, location, id, isEditing]);

    useEffect(() => {
        labelFetch()
    }, [])

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <div>
            {showOverlay && (<Response_Processing />)}
            {!isModal && <AdminBackNavigation text="Back" path="/all-artist" />}
            {!isModal && <AdminSaveHeader loading={showOverlay} heading={!isEditing ? labelDisplay?.[0]?.title : labelDisplay?.[11]?.title} saveText={!isEditing ? labelDisplay?.[10]?.title : labelDisplay?.[10]?.sub_title} saveMethod={handleSubmit} />}
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!isEditing ? labelDisplay?.[1]?.title : formData?.artist_name} />
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <AdminCustomInput id="artist-name" type="text" name="artist_name" value={formData?.artist_name} onChange={handleInput} placeHolder={"Artist Name"} ref={(el) => (combinedRef.current.artist_name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.artist_name} />

                        <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                        <AdminCustomInput id="artist-slug" type="text" name="artist_slug" value={formData?.artist_slug} onChange={handleInput} onBlur={handleBlurEdittitle} placeHolder={"Artist Slug"} ref={(el) => (combinedRef.current.artist_slug = el)} error={formDataError?.artist_slug} />

                        <MessageLabel text={labelDisplay?.[4]?.title} className="" />
                        <AdminCustomInput id="artist-email" type="text" name="artist_email" value={formData?.artist_email} onChange={handleInput} placeHolder={"Artist Email"} ref={(el) => (combinedRef.current.artist_email = el)} error={formDataError?.artist_email} />

                        <MessageLabel text="Artist Type" className="mandatorySimple" />
                        <Select
                            id="artist-type"
                            options={defaultOption?.artistCategoryOption}
                            isMulti
                            name={'artist_type'}
                            ref={(el) => (combinedRef.current.artist_type = el)}
                            onChange={handleMultiSelect}
                            value={formData?.selected_types}
                            className={`${formDataError?.artist_type && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`}
                        />
                        {formDataError?.artist_type && (
                            <div className='d-flex align-items-center gap-1 mb-2'>
                                <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                                <MessageBox text={`${formDataError?.artist_type}`} classname='errorred d-block' />
                            </div>
                        )}

                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[6]?.title} />
                        <MessageLabel text={labelDisplay?.[7]?.title} />
                        <p className=' mb-3 mt-0 theme-text-color opacity-75 admin-input-description'>Select the image( 1:1 Ratio or 1080px (x) 1080px )</p>

                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            id={isEditing ? id : undefined}
                            idAttribute="artist-image"
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.image}
                        />
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[8]?.title} />
                        <MessageLabel text={labelDisplay?.[9]?.title} className="" />
                        <AdminCustomArea id="artist-description" type="text" name="description" value={formData?.description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.description = el)} placeHolder={"Artist Description"} rows={5} />
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' loading={showOverlay} saveMethod={handleSubmit} saveText={!id ? labelDisplay?.[10]?.title : labelDisplay?.[10]?.sub_title} />
            </FormContainer>
        </div>
    )
}

export default ArtistAddUpdate